import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8f58eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { style: {"overflow":"auto","height":"49vh","display":"block"} }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"1.1rem","font-weight":"bold"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Trýst eina ferð á ein stav fyri at skifta litin til ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, "gulan", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" og tvær ferðir fyri at skifta til ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "green" }, "grønan", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "easy" }, "Eg dugi so øgiliga illa!", -1))
const _hoisted_12 = { class: "error" }

import { ref, defineAsyncComponent, shallowRef, ShallowRef, onMounted, watch } from 'vue';
  import { CORRECTNESS } from './Enums';

  interface GuessedWord {
    comp: ShallowRef,
    word: string
  }

  interface Letters {
    word: string,
    letter: string,
    position: number
  }

  interface WrongLetters {
    letter: string,
    position: number
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const guessedWords = ref<GuessedWord[]>([]);
  const word = ref('');
  const error = ref('');
  const showHelp = ref(false);
  const easy = ref(false);

  const correctLetters = ref<Letters[]>([]);
  const partialLetters = ref<Letters[]>([]);
  const wrongLetters = ref<WrongLetters[]>([]);
  const wordListSelect = ref();
  const wordListSelected = ref();

  let words: string[] = [];

  onMounted(() => {
    import('../assets/fo_wordlist.json').then((wordlist) => {
      words = wordlist.default;
    });
  });

  watch(easy, (newValue) => {
    if (newValue) {
      import('../assets/fo_wordlist_easy.json').then((wordlist) => {
        words = wordlist.default;
        getWordlist();
      });
    } else {
      import('../assets/fo_wordlist.json').then((wordlist) => {
        words = wordlist.default;
        getWordlist();
      });
    }
  });

  const addGuess = (() => {
    if (word.value && word.value.length === 5) {
      if (words.includes(word.value.toLowerCase())) {
        error.value = '';
        showHelp.value = true;
        let guess: GuessedWord = {
          comp: shallowRef(defineAsyncComponent({
            loader: () => import('./GuessedLetters.vue')
          })),
          word: word.value.toLowerCase()
        };
        guessedWords.value.push(guess);
        let i = 0;
        for (const ch of word.value) {
          wrongLetters.value.push({letter: ch.toLowerCase(), position: i++});
        }
        word.value = '';
        getWordlist();
      } else {
        error.value = 'Orðið finst ikki í datagrunninum!';
      }
    }
  });

  const letterChanged = (wrd: string, ltr: string, pos: number, correctness: CORRECTNESS) => {
    // console.log('wrd', wrd, 'ltr', ltr, 'pos', pos, 'correctness', correctness);
    if (correctness === CORRECTNESS.WRONG) {
      let idxWrong = wrongLetters.value.findIndex((x) => x.position === pos && x.letter === ltr );
      if (idxWrong > -1)
        wrongLetters.value.splice(idxWrong,1);
      wrongLetters.value.push({
        letter: ltr,
        position: pos
      });

      let idxCorrect = correctLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxCorrect > -1)
        correctLetters.value.splice(idxCorrect,1);

      let idxPartial = partialLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxPartial > -1)
        partialLetters.value.splice(idxPartial,1);
    } else if (correctness === CORRECTNESS.PARTIAL) {
      let idxWrong = wrongLetters.value.findIndex((x) => x.position === pos && x.letter === ltr );
      if (idxWrong > -1)
        wrongLetters.value.splice(idxWrong,1);
      
      let idxCorrect = correctLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxCorrect > -1)
        correctLetters.value.splice(idxCorrect,1);

      let idxPartial = partialLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxPartial > -1)
        partialLetters.value.splice(idxPartial,1);

      partialLetters.value.push({
        word: wrd,
        letter: ltr,
        position: pos
      });
    } else if (correctness === CORRECTNESS.CORRECT) {
      let idxWrong = wrongLetters.value.findIndex((x) => x.position === pos && x.letter === ltr );
      if (idxWrong > -1)
        wrongLetters.value.splice(idxWrong,1);

      let idxPartial = partialLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxPartial > -1)
        partialLetters.value.splice(idxPartial,1);

      let idxCorrect = correctLetters.value.findIndex((x) => x.position === pos && x.word === wrd );
      if (idxCorrect > -1)
        correctLetters.value.splice(idxCorrect,1);

      correctLetters.value.push({
        word: wrd,
        letter: ltr,
        position: pos
      });
    }
    getWordlist();
  };

  const getWordlist = (): void => {
    // Filter out wrong letters
    let notincludedLetters = '';
    for (let letter of wrongLetters.value) {
      notincludedLetters = notincludedLetters + letter.letter;
    }
    // don't filter yellow letters
    for (let letter of partialLetters.value) {
      notincludedLetters = notincludedLetters.replaceAll(letter.letter, '');
    }
    // don't filter green letters
    for (let letter of correctLetters.value) {
      notincludedLetters = notincludedLetters.replaceAll(letter.letter, '');
    }
    let wordList = words.filter(x => noneOf(x, notincludedLetters));

    // All partial letters must be included
    let includedLetters = '';
    for (let letter of partialLetters.value) {
      includedLetters = includedLetters + letter.letter;
    }
    wordList = wordList.filter(x => allOf(x, includedLetters));

    // partial letters must not be in current position
    for (let letter of partialLetters.value) {
      wordList = wordList.filter(x => x.charAt(letter.position) !== letter.letter);
    }

    // correct letters must be in current position
    for (let letter of correctLetters.value) {
      wordList = wordList.filter(x => x.charAt(letter.position) === letter.letter);
    }

    wordListSelect.value = Array.from(wordList.sort(Intl.Collator('da').compare), (x) => ({ label: x, value: x }));
  };

  const noneOf = (word: string, ignoreLetters: string): boolean => {
    var i = ignoreLetters.length;
    while (i--) {
      if (word.toLowerCase().indexOf(ignoreLetters.toLowerCase().charAt(i)) !== -1)
        return false;
    }
    return true;
  };

  const allOf = (word: string, includeLetters: string): boolean => {
    var i = includeLetters.length;
    while (i--) {
      if (!word.toLowerCase().includes(includeLetters.toLowerCase().charAt(i)))
        return false;
    }
    return true;
  };

  const selectWord = (evt: Event) => {
    evt.preventDefault();
    evt.stopPropagation();
    clearSelection();
    const el = evt.target as HTMLLIElement;
    word.value = el.innerText;
  };

  const clearSelection = () => {
    const sel = window.getSelection();
    if (sel)
      sel.removeAllRanges();
  };

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (showHelp.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_9))
          : _createCommentVNode("", true),
        (showHelp.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createVNode(_component_Checkbox, {
                id: "easy",
                modelValue: easy.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((easy).value = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guessedWords.value, (guessedWord) => {
        return (_openBlock(), _createElementBlock("div", {
          key: guessedWord.word
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(guessedWord.comp), {
            word: guessedWord.word,
            onLetterChanged: letterChanged
          }, null, 8, ["word"]))
        ]))
      }), 128)),
      _createElementVNode("div", null, [
        _createVNode(_component_InputText, {
          modelValue: word.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((word).value = $event)),
          type: "text",
          maxlength: "5",
          placeholder: "Orð, tú hevur gitt..",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (addGuess()), ["enter"]))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Button, {
          label: "Skráset",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addGuess()))
        })
      ]),
      _createElementVNode("div", _hoisted_12, _toDisplayString(error.value), 1)
    ]),
    (showHelp.value)
      ? (_openBlock(), _createBlock(_component_Listbox, {
          key: 0,
          modelValue: wordListSelected.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((wordListSelected).value = $event)),
          options: wordListSelect.value,
          "option-value": "value",
          "option-label": "label",
          filter: true,
          "filter-placeholder": "Leita..",
          "empty-message": "Onki orð funnið!",
          "list-style": "height: 44vh;",
          style: {"position":"fixed","bottom":"0%","left":"0%","right":"0%","width":"100%"},
          onDblclick: selectWord
        }, null, 8, ["modelValue", "options"]))
      : _createCommentVNode("", true)
  ]))
}
}

})